import { ExcelDownloadReasonModal as StockLedgerExcelDownloadReasonModal } from '@/pages/inventory/stockLedger/components/ExcelDownloadReasonModal'
import type { DailyCloseDownloadReason } from '@/services/inventory/dailyClose/types'

interface Props {
  open: boolean
  onConfirm: (reason: DailyCloseDownloadReason) => void
  onCancel: () => void
}

/** ST10과 같은 다운로드 사유 모달을 RP13 요청 타입에 연결한다. */
export function ExcelDownloadReasonModal(props: Readonly<Props>) {
  return <StockLedgerExcelDownloadReasonModal {...props} />
}
